/* eslint-disable no-else-return */
/* eslint-disable vars-on-top */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-return-assign */
/* eslint-disable spaced-comment */
/* eslint-disable max-classes-per-file */
/* eslint-disable no-var */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable dot-notation */
import { LiteralObject } from 'viggo-sistemas-core-web';

class TipoContasAtraso {
  result: string;
  constructor(public enumValue: string) {
    if (enumValue === 'RESTRITO') {
      this.result = 'RESTRITO';
    } else if (enumValue === 'LIBERADO_AVISTA') {
      this.result = 'LIBERADO_AVISTA';
    } else if (enumValue === 'LIBERADO_FULL') {
      this.result = 'LIBERADO_FULL';
    } else {
      this.result = 'UNKNOWN';
    }
  }
}
class TipoOperacoesFinanceiro {
  result: string;
  constructor(public enumValue: string) {
    if (enumValue === 'COMPR_MERC_REV') {
      this.result = 'COMPR_MERC_REV';
    } else if (enumValue === 'COMPR_MERC_CONS') {
      this.result = 'COMPR_MERC_CONS';
    } else if (enumValue === 'CONS_SERV') {
      this.result = 'CONS_SERV';
    } else if (enumValue === 'VEND_MERC') {
      this.result = 'VEND_MERC';
    } else if (enumValue === 'FAB_PROD') {
      this.result = 'FAB_PROD';
    } else {
      this.result = 'UNKNOWN';
    }
  }
}

class TipoValorMinimoProduto {
  result: string;
  constructor(public enumValue: string) {
    if (enumValue === 'TABELA_PRECO') {
      this.result = 'TABELA_PRECO';
    } else if (enumValue === 'PRODUTO') {
      this.result = 'PRODUTO';
    } else {
      this.result = 'UNKNOWN';
    }
  }
}

class TipoBaixarEstoque {
  result: string;
  constructor(public enumValue: string) {
    if (enumValue === 'FATURAR_PEDIDO') {
      this.result = 'FATURAR_PEDIDO';
    } else if (enumValue === 'LIBERAR_PEDIDO') {
      this.result = 'LIBERAR_PEDIDO';
    } else {
      this.result = 'UNKNOWN';
    }
  }
}

class TipoPerdeGanha {
  result: string;
  constructor(public enumValue: string) {
    if (enumValue === 'VENDEDOR') {
      this.result = 'VENDEDOR';
    } else if (enumValue === 'PEDIDO') {
      this.result = 'PEDIDO';
    } else {
      this.result = 'UNKNOWN';
    }
  }
}

class TipoFaturarAuto {
  result: string;
  constructor(public enumValue: string) {
    if (enumValue === 'NFE') {
      this.result = 'NFE';
    } else if (enumValue === 'PEDIDO') {
      this.result = 'PEDIDO';
    } else {
      this.result = 'UNKNOWN';
    }
  }
}

export class ValidadorSettingsDomain {
  // INFORMACAO DA INTEGRACAO
  versao_integracao = '0';
  versao_sistema_integrado = '0';
  modulo_sistema_integrado = 'PROJETO';

  // primeiros passos
  passos = [
    {
      posicao: 0,
      passo_valor: 'INFO_EMPRESA',
      titulo: 'Informações da empresa',
      descricao:
        'Vamos adicionar algumas informações sobre ' +
        'o seu negócio? \nO primeiro passo é inserir informações ' +
        'da sua empresa, como logo, nome, informações sobre seu ' +
        'ramo de negócios, endereço  e contatos. Essas ' +
        'informações que serão adicionadas aqui servirão ' +
        'para nós e seus clientes sabermos um pouco mais ' +
        'sobre sua empresa e facilitar a identificação nas ' +
        'nossas bases. ',
      concluido: false
    },
    {
      posicao: 1,
      passo_valor: 'INFO_EMPRESA_REGRAS',
      titulo: 'Configurações das regras de negócio',
      descricao:
        'Agora precisamos saber: como seu negócio ' +
        'funciona? \nO segundo passo é definir como o ' +
        'sistema deve agir para melhor atender as suas ' +
        'necessidades! Existem algumas regras de configuração ' +
        'que precisam ser ativadas ou desativadas para facilitar ' +
        'todo o seu controle. Caso não entenda do que se trata ' +
        'cada marcação, basta consultar os ícones informativos ' +
        'ao lado dos campos!',
      concluido: false
    },
    {
      posicao: 2,
      passo_valor: 'INFO_FISCAL',
      titulo: 'Informações fiscais da empresa',
      descricao:
        'Nesse momento é importante que todos os ' +
        'dados da sua empresa sejam preenchidos corretamente, ' +
        'pois iremos cadastrar agora sua empresa como emitente! ' +
        '\nNo terceiro passo, é necessário preencher todas as ' +
        'informações sobre sua empresa que necessitam para ' +
        'emissão de documentos fiscais como CNPJ, razão social, ' +
        'inscrição estadual e municipal, ou seja, o que for ' +
        'necessário para podermos emitir os seus documentos ' +
        'fiscais com o emitente correto.',
      concluido: false
    },
    {
      posicao: 3,
      passo_valor: 'INFO_FISCAL_REGRAS',
      titulo: 'Configurações da emissão de notas fiscais',
      descricao:
        'Esse passo é extremamente importante, ' +
        'nele o sistema entenderá como deve proceder durante ' +
        'a emissão das notas! \nNo quarto passo deve ser ' +
        'inseridas as informações referentes ao cadastro da ' +
        'sua série fiscal, o ambiente de emissão (produção ou ' +
        'homologação) e, caso tenha adquirido o pacote com ' +
        'NFCe, adicionar também o código do contribuinte, ' +
        'entre outras informações solicitadas.',
      concluido: false
    },
    {
      posicao: 4,
      passo_valor: 'INFO_CERTIFICADO',
      titulo: 'Configuração do certificado',
      descricao:
        'Para emissão de documentos fiscais é ' +
        'indispensável o uso de certificação digital da sua ' +
        'empresa, então esteja sempre com ele em dia! \nNo ' +
        'quinto passo deve ser enviado o certificado digital ' +
        'que sua empresa usa e a senha. Essas informações vão ' +
        'ser salvas no nosso servidor, pois sempre que for ' +
        'necessário a emissão de um documento fiscal o ' +
        'certificado estará disponível para consulta.',
      concluido: false
    },
    {
      posicao: 5,
      passo_valor: 'INFO_UFICMS',
      titulo: 'Configuração das alíquotas estaduais',
      descricao:
        'Por fim, o último passo , o preenchimento ' +
        'das alíquotas estaduais! As alíquotas são imposto de ' +
        'âmbito estadual e por isso somente os governos dos ' +
        'Estados e do Distrito Federal podem instituí-lo. ' +
        'Por isso, é importante manter em mãos a Tabela ICMS ' +
        'sempre atualizada. \nNesse último passo, precisamos ' +
        'que configure as porcentagens(alíquotas) utilizadas em ' +
        'cada estado que você emite nota. em caso de dúvidas, ' +
        'consulte o contador!',
      concluido: false
    }
  ];

  ultimo_passo = 'UNKNONW';

  // PRODUTO
  valor_minimo = null;
  baixar_estoque = null;
  controle_estoque = false;
  oculta_estoque_zerado = false;

  // CAIXA_PDV
  nfce_auto = false;
  registro_caixa = false;
  forcar_fechamento_caixa = false;
  fechamento_as_cegas = false;
  conferencia_auto = false;

  // CONTAS_RECEBER
  contas_atraso = null;
  taxa_juros_mes = 0;
  dias_tolerancia_juros = 0;

  // CLIENTES
  limite_credito = false;
  obriga_contato_pre_cadastro = false;

  // VENDEDOR
  perde_ganha = null;

  // PEDIDO
  valida_cliente_pedido = false;
  transforma_pre_pedido = false;
  fatura_auto = null;

  // DESCONTO
  bloquear_desconto = false;
  acrescimo_max = 100;
  desconto_max = 100;

  // FINANCEIRO
  operacao_padrao_receber = null;
  operacao_padrao_pagar = null;
  operacoes = [];
  observables_fin = [];
  observables_centro = [];

  // CATALOGO
  gerar_pre_venda = false;
  add_item_estoque_vazio = false;

  constructor(
    public domain_settings: LiteralObject,
    public application_settings = {}
  ) {
    const domain_regras = domain_settings['regras'] ?? {};
    const domain_public_regras = domain_settings['public'] ?? {};
    const domain_config_inicial = domain_settings['config_inicial'] ?? {};
    const domain_info_integracao =
      domain_settings['informacao_integracao'] ?? {};

    const controle = domain_regras['controle'] ?? {};
    const caixa_pdv = domain_regras['caixa_pdv'] ?? {};
    const financeiro = domain_regras['config_financeira'] ?? {};
    const catalogo = domain_public_regras['catalogo'] ?? {};

    const produto = controle['produto'] ?? {};
    const conta_receber = controle['conta_receber'] ?? {};
    const cliente = controle['cliente'] ?? {};
    const vendedor = controle['vendedor'] ?? {};
    const desconto = controle['desconto'] ?? {};
    const pedido = controle['pedido'] ?? {};

    //PASSOS
    if (domain_config_inicial['passos'])
      this.passos = domain_config_inicial['passos'];
    this.ultimo_passo = domain_config_inicial['ultimo_passo'] ?? 'UNKNOWN';

    //INFO INTEGRACAO
    this.versao_integracao = domain_info_integracao['versao_integracao'] ?? '0';
    this.versao_sistema_integrado =
      domain_info_integracao['versao_sistema_integrado'] ?? '0';
    this.modulo_sistema_integrado =
      domain_info_integracao['modulo_sistema_integrado'] ?? 'UNKNOWN';

    //PRODUTO
    this.controle_estoque = produto['controle_estoque'] ?? false;
    this.oculta_estoque_zerado = produto['oculta_estoque_zerado'] ?? false;
    this.valor_minimo = this.getTipoProdutoValorMinimo(produto);
    this.baixar_estoque = this.getTipoBaixarEstoque(produto);

    //DESCONTO
    this.bloquear_desconto = desconto['bloquear_desconto'] ?? false;
    this.acrescimo_max = desconto['acrescimo_max'] ?? 100;
    this.desconto_max = desconto['desconto_max'] ?? 100;

    //CONTA_RECEBER
    this.contas_atraso = this.getTipoContasAtraso(conta_receber);
    this.taxa_juros_mes = conta_receber['taxa_juros_mes'] ?? 0;
    this.dias_tolerancia_juros = conta_receber['dias_tolerancia_juros'] ?? 0;

    //CLIENTE
    this.limite_credito = cliente['limite_credito'] ?? false;
    this.obriga_contato_pre_cadastro =
      cliente['obriga_contato_pre_cadastro'] ?? false;

    //VENDEDOR
    this.perde_ganha = this.getTipoPerdeGanha(vendedor);

    //PEDIDO
    this.valida_cliente_pedido = pedido['valida_cliente_pedido'] ?? false;
    this.transforma_pre_pedido = pedido['transforma_pre_pedido'] ?? false;
    this.fatura_auto = this.getTipoFaturarAuto(pedido);

    //FINANCEIRO
    this.operacao_padrao_pagar = this.getOperacaoPadrao(financeiro, 'PAGAR');
    this.operacao_padrao_receber = this.getOperacaoPadrao(
      financeiro,
      'RECEBER'
    );
    this.operacoes = financeiro['operacoes'] ?? [];
    this.observables_centro = financeiro['observables_centro'] ?? [];
    this.observables_fin = financeiro['observables_fin'] ?? [];

    //CAIXA_PDV
    this.nfce_auto = caixa_pdv['nfce_auto'] ?? false;
    this.registro_caixa = caixa_pdv['registro_caixa'] ?? false;
    this.forcar_fechamento_caixa =
      caixa_pdv['forcar_fechamento_caixa'] ?? false;
    this.fechamento_as_cegas = caixa_pdv['fechamento_as_cegas'] ?? false;
    this.conferencia_auto = caixa_pdv['conferencia_auto'] ?? false;

    //CATALOGO
    this.gerar_pre_venda = catalogo['gerar_pre_venda'] ?? false;
    this.add_item_estoque_vazio = catalogo['add_item_estoque_vazio'] ?? false;
  }

  getTipoProdutoValorMinimo(settings) {
    var op = settings['valor_minimo'] ?? 'UNKNOWN';
    if (op === undefined) {
      op = 'UNKNOWN';
    }
    return new TipoValorMinimoProduto(op).result;
  }

  getTipoFaturarAuto(settings) {
    var op = settings['fatura_auto'] ?? 'UNKNOWN';
    if (op === undefined) {
      op = 'UNKNOWN';
    }
    return new TipoFaturarAuto(op).result;
  }

  getTipoPerdeGanha(settings) {
    var op = settings['perde_ganha'] ?? 'UNKNOWN';
    if (op === undefined) {
      op = 'UNKNOWN';
    }
    return new TipoPerdeGanha(op).result;
  }

  getTipoBaixarEstoque(settings) {
    var op = settings['baixar_estoque'] ?? 'UNKNOWN';
    if (op === undefined) {
      op = 'UNKNOWN';
    }
    return new TipoBaixarEstoque(op).result;
  }

  getOperacaoPadrao(settings, type: string) {
    if (type === 'RECEBER') {
      var op_receber_caixa = settings['operacao_padrao_receber'] ?? 'UNKNOWN';
      if (op_receber_caixa === undefined) {
        op_receber_caixa = 'UNKNOWN';
      }
      return new TipoOperacoesFinanceiro(op_receber_caixa).result;
    } else {
      var op_pagar = settings['operacao_padrao_pagar'] ?? 'UNKNOWN';
      if (op_pagar === undefined) {
        op_pagar = 'UNKNOWN';
      }
      return new TipoOperacoesFinanceiro(op_pagar).result;
    }
  }

  getTipoContasAtraso(settings) {
    var op = settings['contas_atraso'] ?? 'UNKNOWN';
    if (op === undefined) {
      op = 'UNKNOWN';
    }
    return new TipoContasAtraso(op).result;
  }

  getDomainSettingsBody(domain_settings) {
    return (domain_settings = {
      regras: {
        controle: {
          desconto: {
            bloquear_desconto: this.bloquear_desconto,
            acrescimo_max: this.acrescimo_max,
            desconto_max: this.desconto_max
          },
          produto: {
            controle_estoque: this.controle_estoque,
            valor_minimo: this.valor_minimo,
            baixar_estoque: this.baixar_estoque,
            oculta_estoque_zerado: this.oculta_estoque_zerado
          },
          cliente: {
            limite_credito: this.limite_credito,
            obriga_contato_pre_cadastro: this.obriga_contato_pre_cadastro
          },
          vendedor: {
            perde_ganha: this.perde_ganha
          },
          conta_receber: {
            contas_atraso: this.contas_atraso,
            taxa_juros_mes: this.taxa_juros_mes,
            dias_tolerancia_juros: this.dias_tolerancia_juros
          },
          pedido: {
            valida_cliente_pedido: this.valida_cliente_pedido,
            transforma_pre_pedido: this.transforma_pre_pedido,
            fatura_auto: this.fatura_auto
          }
        },
        caixa_pdv: {
          nfce_auto: this.nfce_auto,
          registro_caixa: this.registro_caixa,
          forcar_fechamento_caixa: this.forcar_fechamento_caixa,
          fechamento_as_cegas: this.fechamento_as_cegas,
          conferencia_auto: this.conferencia_auto
        },
        config_financeira: {
          operacoes: this.operacoes,
          operacao_padrao_pagar: this.operacao_padrao_pagar,
          operacao_padrao_receber: this.operacao_padrao_receber,
          observables_centro: this.observables_centro,
          observables_fin: this.observables_fin
        }
      },
      public: {
        catalogo: {
          gerar_pre_venda: this.gerar_pre_venda,
          add_item_estoque_vazio: this.add_item_estoque_vazio
        }
      },
      informacao_integracao: {
        versao_integracao: this.versao_integracao,
        versao_sistema_integrado: this.versao_sistema_integrado,
        modulo_sistema_integrado: this.modulo_sistema_integrado
      },
      config_inicial: {
        passos: this.passos,
        ultimo_passo: this.ultimo_passo
      }
    });
  }
}
